import { Component } from '@angular/core';

@Component({
  selector: 'app-edit-company',
  template: `
    <p>
      edit-company works!
    </p>
  `,
  styles: ``
})
export class EditCompanyComponent {

}
